export default __webpack_public_path__ + "static/media/blip-smiley.bb88940f.svg";